import React, { FC } from "react";

/**
 * Texto que será exibido somente para leitores de tela
 */
export const SRText: FC = (props) => {
  return <span className='sr-only'>{props.children}</span>
};
